import React, { useState } from "react";
import { oneOfType, array, string, bool, shape } from "prop-types";

import moment from "moment";

import GridTable from "pages/_components/GridTable/GridTable";
import * as i18n from "util/i18n";
import { Row, Col } from "react-bootstrap";
import CustomText from "pages/_components/CustomText/CustomText";
import Button from "pages/_components/Button";
import "react-circular-progressbar/dist/styles.css";
import FormattedAmount from "pages/_components/FormattedAmount";
import CustomData from "pages/_components/CustomData/CustomData";
import getCellPlacement from "../../../../util/helpers/table";

const LoanDetailViewMore = ({ activeLoans, isDesktop, detallePrestamo, idLoan }) => {
    const [showMore, setShowMore] = useState(false);
    const prestamoActual = activeLoans.find((x) => x.nroPrestamo === Number(idLoan));
    const commission = detallePrestamo.retenciones?.find((retention) => retention.codigo === "92");
    const getCellProps = (row, col, cols) => getCellPlacement(row, col, { isDesktop, totalColumns: cols });

    return (
        <>
            <Row className="loans__show-more">
                <Col className="right-content" lg={12}>
                    <Button
                        className="btn pr-0"
                        onClick={() => {
                            setShowMore(!showMore);
                        }}
                        image={showMore ? "images/figma/icon/arrow-up.svg" : "images/figma/icon/arrow-down.svg"}
                        block={false}
                        defaultLabelText={showMore ? "Ver menos" : "Ver más"}
                        bsStyle="link toolbar-btn view-back"
                    />
                </Col>
            </Row>
            {showMore && (
                <GridTable className="grid-table-form show-more-table">
                    <div className={`view-more-data full-width ${showMore ? "expand " : "collapse"}`}>
                        <h3 className="col-span-full">{i18n.get("unsecured.loans.confirm.detailLoan.title")}</h3>
                        <GridTable.Body>
                            <GridTable.Container className="loans__show-more-container px-0" key="1551_1">
                                <GridTable.Data
                                    columnStart={1}
                                    columnWidth={1}
                                    rowStart={1}
                                    className="modalities"
                                    alignX="flex-start"
                                    alignY="start"
                                    flexDirection={isDesktop ? "row" : "column"}>
                                    <CustomData
                                        titleText={i18n.get("loans.customLoan.form.amount")}
                                        titleTextType="STRING"
                                        valueText={
                                            <FormattedAmount currency="ARS" quantity={prestamoActual.montoAcreditado} />
                                        }
                                        valueTextType="STRING"
                                    />
                                </GridTable.Data>
                                <GridTable.Data
                                    columnWidth={1}
                                    className="modalities"
                                    alignX="flex-start"
                                    alignY="start"
                                    flexDirection={isDesktop ? "row" : "column"}
                                    {...getCellProps(1, 2, 3)}>
                                    <CustomData
                                        titleText={i18n.get(
                                            "unsecured.loans.confirm.debitCreditAccount",
                                            "Cuenta de acreditación y débito",
                                        )}
                                        titleTextType="TEXT"
                                        valueTextType="TEXT"
                                        valueText={
                                            <CustomText
                                                text={`${i18n.get(`productType.${detallePrestamo?.tipoCuenta}`)} 
                                            ····${detallePrestamo?.numeroCuenta?.slice(-4)}
                                            ${i18n.get("currency.label.ARS")}`}
                                            />
                                        }
                                    />
                                </GridTable.Data>
                                <GridTable.Data
                                    columnWidth={1}
                                    className="modalities"
                                    alignX="flex-start"
                                    alignY="start"
                                    flexDirection={isDesktop ? "row" : "column"}
                                    {...getCellProps(1, 3, 3)}>
                                    <CustomData
                                        titleText={i18n.get("unsecured.loans.confirm.duration")}
                                        titleTextType="STRING"
                                        valueText={`${detallePrestamo?.cuotas.length} meses`}
                                        valueTextType="TEXT"
                                    />
                                </GridTable.Data>

                                <GridTable.Data
                                    columnWidth={1}
                                    className="modalities"
                                    alignX="flex-start"
                                    alignY="start"
                                    flexDirection={isDesktop ? "row" : "column"}
                                    {...getCellProps(2, 1, 3)}>
                                    <CustomData
                                        titleText={i18n.get("unsecured.loans.confirm.amountOfInstallments")}
                                        titleTextType="STRING"
                                        valueText={`${detallePrestamo?.cuotas.length} cuotas`}
                                        valueTextType="TEXT"
                                    />
                                </GridTable.Data>
                                <GridTable.Data
                                    columnWidth={1}
                                    className="modalities"
                                    alignX="flex-start"
                                    alignY="start"
                                    flexDirection={isDesktop ? "row" : "column"}
                                    {...getCellProps(2, 2, 3)}>
                                    <CustomData
                                        titleText={i18n.get("loans.list.tab.historicalLoans.card.accreditationDate")}
                                        titleTextType="STRING"
                                        valueText={moment(detallePrestamo?.fechaDeLiquidacion)
                                            .utc()
                                            .format("DD/MM/YYYY")}
                                        valueTextType="TEXT"
                                    />
                                </GridTable.Data>
                                <GridTable.Data
                                    columnWidth={1}
                                    className="modalities"
                                    alignX="flex-start"
                                    alignY="start"
                                    flexDirection={isDesktop ? "row" : "column"}
                                    {...getCellProps(2, 3, 3)}>
                                    <CustomData
                                        titleText={i18n.get("unsecured.loans.confirm.amortizationType")}
                                        titleTextType="STRING"
                                        valueText={i18n.get(`unsecured.loans.types.${detallePrestamo?.tipoPrestamo}`)}
                                        valueTextType="TEXT"
                                    />
                                </GridTable.Data>

                                <GridTable.Data
                                    columnWidth={1}
                                    className="modalities"
                                    alignX="flex-start"
                                    alignY="start"
                                    flexDirection={isDesktop ? "row" : "column"}
                                    {...getCellProps(3, 1, 3)}>
                                    <CustomData
                                        titleText={i18n.get("unsecured.loans.simulation.first.installment")}
                                        titleTextType="STRING"
                                        valueText={
                                            <FormattedAmount
                                                currency="ARS"
                                                quantity={detallePrestamo?.cuotas[0]?.totalCuota}
                                            />
                                        }
                                        valueTextType="TEXT"
                                    />
                                </GridTable.Data>
                                <GridTable.Data
                                    columnWidth={1}
                                    className="modalities"
                                    alignX="flex-start"
                                    alignY="start"
                                    flexDirection={isDesktop ? "row" : "column"}
                                    {...getCellProps(3, 2, 3)}>
                                    <CustomData
                                        titleText={i18n.get("unsecured.loans.simulation.last.installment")}
                                        titleTextType="STRING"
                                        valueText={
                                            <FormattedAmount
                                                currency="ARS"
                                                quantity={
                                                    detallePrestamo?.cuotas[detallePrestamo.cuotas.length - 1]
                                                        ?.totalCuota
                                                }
                                            />
                                        }
                                        valueTextType="TEXT"
                                    />
                                </GridTable.Data>
                                <GridTable.Data
                                    columnWidth={1}
                                    className="modalities"
                                    alignX="flex-start"
                                    alignY="start"
                                    flexDirection={isDesktop ? "row" : "column"}
                                    {...getCellProps(3, 3, 3)}>
                                    <CustomData
                                        titleText={i18n.get("unsecured.loans.confirm.commissions")}
                                        titleTextType="STRING"
                                        valueText={<FormattedAmount currency="ARS" quantity={commission.monto} />}
                                        valueTextType="TEXT"
                                    />
                                </GridTable.Data>
                            </GridTable.Container>

                            <hr className="dotted" />

                            <h3 className="col-span-full">{i18n.get("unsecured.loans.simulation.rate.subtitle")}</h3>

                            <GridTable.Container className="loans__show-more-container px-0" key="1551_2">
                                <GridTable.Data
                                    columnWidth={1}
                                    rowStart={1}
                                    className="modalities"
                                    alignX="flex-start"
                                    alignY="start"
                                    flexDirection={isDesktop ? "row" : "column"}
                                    {...getCellProps(1, 1, 3)}>
                                    <CustomData
                                        titleText={i18n.get("unsecured.loans.simulation.rate.type")}
                                        titleTextType="STRING"
                                        valueText={detallePrestamo?.tipoDeTasa}
                                        valueTextType="TEXT"
                                    />
                                </GridTable.Data>
                                <GridTable.Data
                                    columnWidth={1}
                                    rowStart={1}
                                    className="modalities"
                                    alignX="flex-start"
                                    alignY="start"
                                    flexDirection={isDesktop ? "row" : "column"}
                                    {...getCellProps(1, 2, 3)}>
                                    <CustomData
                                        titleText={i18n.get("unsecured.loans.simulation.rate.tna")}
                                        titleTextType="STRING"
                                        valueText={`${detallePrestamo?.tasas.tna}%`}
                                        valueTextType="TEXT"
                                    />
                                </GridTable.Data>
                                <GridTable.Data
                                    columnWidth={1}
                                    rowStart={1}
                                    className="modalities"
                                    alignX="flex-start"
                                    alignY="start"
                                    flexDirection={isDesktop ? "row" : "column"}
                                    {...getCellProps(1, 3, 3)}>
                                    <CustomData
                                        titleText={i18n.get("unsecured.loans.simulation.rate.tea")}
                                        titleTextType="STRING"
                                        valueText={`${detallePrestamo?.tasas.tea}%`}
                                        valueTextType="TEXT"
                                    />
                                </GridTable.Data>
                                <GridTable.Data
                                    columnWidth={1}
                                    rowStart={1}
                                    className="modalities"
                                    alignX="flex-start"
                                    alignY="start"
                                    flexDirection={isDesktop ? "row" : "column"}
                                    {...getCellProps(2, 1, 3)}>
                                    <CustomData
                                        titleText={i18n.get("unsecured.loans.simulation.rate.cftea")}
                                        titleTextType="STRING"
                                        valueText={`${detallePrestamo?.cft?.cftSinIva}%`}
                                        valueTextType="TEXT"
                                    />
                                </GridTable.Data>
                                <GridTable.Data
                                    columnWidth={1}
                                    rowStart={1}
                                    className="modalities"
                                    alignX="flex-start"
                                    alignY="start"
                                    flexDirection={isDesktop ? "row" : "column"}
                                    {...getCellProps(2, 2, 3)}>
                                    <CustomData
                                        titleText={i18n.get("unsecured.loans.simulation.rate.cftea.iva")}
                                        titleTextType="STRING"
                                        valueText={`${detallePrestamo?.cft?.cftConIva}%`}
                                        valueTextType="TEXT"
                                    />
                                </GridTable.Data>
                            </GridTable.Container>
                        </GridTable.Body>
                    </div>
                </GridTable>
            )}
        </>
    );
};

LoanDetailViewMore.propTypes = {
    detallePrestamo: shape({}).isRequired,
    activeLoans: oneOfType([array]).isRequired,
    isDesktop: oneOfType([string, bool]),
    idLoan: string.isRequired,
};

LoanDetailViewMore.defaultProps = {
    isDesktop: false,
};

export default LoanDetailViewMore;
